<template>
  <div class="addevent-page">

    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Ajouter un Article</h1>
      <div class="page-title-bar"></div>
      <p class="page-subtitle">Création d'un nouvel article</p>
    </div>

    <v-container class="form-container">
      <v-row justify="center">
        <v-col cols="12" md="8">

          <!-- Alerts -->
          <v-alert v-if="errors.length" type="error" variant="tonal" class="mb-4" closable>
            <div v-for="error in errors" :key="error">{{ error }}</div>
          </v-alert>
          <v-alert v-if="status.length" type="success" variant="tonal" class="mb-4">
            Article ajouté avec succès.
          </v-alert>

          <v-card elevation="1" rounded="lg" class="form-card">
            <div class="form-card-header">
              <v-icon color="white" size="18" class="mr-2">mdi-newspaper-variant-outline</v-icon>
              Informations de l'article
            </div>

            <v-form ref="form" v-model="valid" class="form-body">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="date"
                    label="Date"
                    type="date"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-calendar-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="event_type"
                    :items="event_types"
                    label="Type d'article"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-tag-outline"
                    :return-object="true"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    label="Titre"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-format-title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="description"
                    label="Description"
                    variant="outlined"
                    density="compact"
                    rows="5"
                    counter
                    required
                  ></v-textarea>
                </v-col>
              </v-row>

              <!-- File uploads -->
              <div class="upload-section">
                <div class="upload-item">
                  <div class="upload-label">
                    <v-icon size="16" color="#E65100">mdi-file-pdf-box</v-icon>
                    Document (PDF)
                  </div>
                  <label class="file-input-label">
                    <input type="file" ref="file" @change="handleFileUpload()" class="file-input" />
                    <span class="file-name">{{ fileName || 'Choisir un fichier…' }}</span>
                  </label>
                </div>
                <div class="upload-item">
                  <div class="upload-label">
                    <v-icon size="16" color="#E65100">mdi-image-outline</v-icon>
                    Image
                  </div>
                  <label class="file-input-label">
                    <input type="file" ref="picture" @change="handlePictureUpload()" class="file-input" />
                    <span class="file-name">{{ pictureName || 'Choisir une image…' }}</span>
                  </label>
                </div>
              </div>

              <!-- Actions -->
              <div class="form-actions">
                <v-btn :to="{ name: 'Dashboard' }" variant="outlined" color="#9e9e9e" rounded="lg">
                  <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                  Retour
                </v-btn>
                <v-btn :disabled="!valid" color="#E65100" variant="flat" rounded="lg" @click="validate">
                  <v-icon size="16" class="mr-1">mdi-check</v-icon>
                  Enregistrer
                </v-btn>
              </div>

            </v-form>
          </v-card>

        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 10),
      description: null,
      event_type: null,
      file: '',
      picture: '',
      fileName: '',
      pictureName: '',
      title: null,
      event_types: [],
      errors: [],
      status: []
    }
  },
  mounted () {
    this.getEventTypes()
  },
  methods: {
    getEventTypes () {
      this.$apiclient.getEventTypes()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.event_types = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      this.fileName = this.file ? this.file.name : ''
    },
    handlePictureUpload () {
      this.picture = this.$refs.picture.files[0]
      this.pictureName = this.picture ? this.picture.name : ''
    },
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = []
        this.$apiclient.addEvent(this.date, this.title, this.event_type, this.description, this.file, this.picture)
          .then(response => {
            if (response.status !== 200) this.errors.push(response.statusText)
            else this.status.push('Ok')
          })
          .catch(error => {
            if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
            else this.errors.push(error.response.statusText)
          })
      })
    }
  }
}
</script>

<style scoped>
.addevent-page {
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  padding: 32px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.page-title-bar {
  width: 40px;
  height: 3px;
  background: #E65100;
  margin: 0 auto 12px;
  border-radius: 2px;
}

.page-subtitle {
  font-size: 0.85rem;
  color: #757575;
  margin: 0;
}

.form-container {
  max-width: 860px;
  padding-top: 32px;
  padding-bottom: 48px;
}

.form-card {
  overflow: hidden;
}

.form-card-header {
  background: #E65100;
  color: white;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 14px 20px;
  display: flex;
  align-items: center;
}

.form-body {
  padding: 24px 24px 20px;
}

.upload-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
}

.upload-item {
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
}

.upload-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #E65100;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.file-input-label {
  display: block;
  cursor: pointer;
}

.file-input {
  display: block;
  font-size: 0.82rem;
  color: #555;
  width: 100%;
}

.file-name {
  font-size: 0.82rem;
  color: #757575;
  font-style: italic;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}
</style>
